import type { LoadingOverlayProps as MantineLoadingOverlayProps } from '@mantine/core';
import { LoadingOverlay as MantineLoadingOverlay } from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';

export type LoadingOverlayProps = MantineLoadingOverlayProps & {
	debounce?: number;
	name?: string;
};

export function LoadingOverlay(props: LoadingOverlayProps) {
	const [debouncedVisible] = useDebouncedValue(props.visible, props.debounce ?? 0);
	// console.debug('LoadingOverlay', props, debouncedVisible);
	// Debounce only on `true` values, `false` values should be shown immediately
	return <MantineLoadingOverlay {...props} visible={debouncedVisible && props.visible} />;
}
